import React from 'react';

const ShareButton = ({ recipe, onShare }) => (
  <button
    type="button"
    className="recipe-share-button"
    aria-label="Share recipe"
    onClick={(e) => {
      e.stopPropagation();
      onShare(recipe);
    }}
  >
    <span className="material-symbols-rounded" aria-hidden="true">
      share
    </span>
  </button>
);

export default ShareButton;
